;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('ArtImportService', artImportService)

  /* @ngInject */
  function artImportService (ConnectorWebService, CONSTANTS, Utils, Upload) {
    var service = {
      uploadImages: uploadImages,
      getUploadedImages: getUploadedImages
    }
    return service

    function uploadImages (aImages) {
      return Upload.upload({
        url: CONSTANTS.URL_ART_IMPORT,
        data: {
          file: aImages,
          isTemporary: true
        }
      })
    }

    function mapGetResponse (oRes) {
      oRes.d.results = oRes.d.results.map(function (oImportedArt) {
        return {
          id: oImportedArt.id,
          contentType: oImportedArt.contentType,
          name: oImportedArt.name,
          size: oImportedArt.size,
          width: oImportedArt.width,
          height: oImportedArt.height,
          src: {
            original: Utils.fnReplaceStringParams(CONSTANTS.URL_ART_IMPORT_ID, [oImportedArt.id]),
            thumbnail: Utils.fnReplaceStringParams(CONSTANTS.URL_ART_IMPORT_ID_THUMBNAIL, [oImportedArt.id])
          }
        }
      })

      return oRes
    }

    function getUploadedImages (iTop, iSkip) {
      var sUrl = CONSTANTS.URL_ART_IMPORT

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      return ConnectorWebService.get(sUrl)
        .then(mapGetResponse, function (error) {
          return error
        })
    }
  }
})()
